import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef, MatSnackBar } from '@angular/material';
import { GatewayService } from 'src/app/gateway.service';

/**
 * Formulario modal para crear/editar un mapeo escenario_area.
 * Los escenarios son un catalogo de numeros (1-7) conocidos por el app movil:
 *   1 - No marcado en camino
 *   2 - No marcado en SITIO
 *   3 - No marcado en INICIO
 *   4 - No marcado en FINALIZA
 *   5 - No aparece en mapa (especializado A)
 *   6 - Orden en riesgo (especializado B)
 *   7 - Planta externa
 */
@Component({
  selector: 'app-escenario-area-form',
  templateUrl: './escenario-area-form.component.html',
  styleUrls: ['./escenario-area-form.component.scss']
})
export class EscenarioAreaFormComponent implements OnInit {

  form: FormGroup;
  guardando = false;

  // Catalogo de escenarios (carga desde la tabla escenario_alarma; el componente
  // padre lo pasa via dialog data).

  esEdicion = false;

  constructor(
    private fb: FormBuilder,
    private gateway: GatewayService,
    private snackbar: MatSnackBar,
    public dialogRef: MatDialogRef<EscenarioAreaFormComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.esEdicion = !!(data && data.registro && data.registro.id);
    const r = data && data.registro ? data.registro : {};
    this.form = this.fb.group({
      id: [r.id || null],
      idescenario: [r.idescenario || null, [Validators.required]],
      idareaagente: [r.idareaagente || null, [Validators.required]],
      puede_ver_alarmas: [r.puede_ver_alarmas !== undefined ? r.puede_ver_alarmas : 1],
      puede_gestionar: [r.puede_gestionar !== undefined ? r.puede_gestionar : 0],
      estado: [r.estado !== undefined ? r.estado : 1]
    });
  }

  ngOnInit() { }

  get areas(): any[] {
    return (this.data && this.data.areas) || [];
  }

  get escenariosCatalogo(): any[] {
    return (this.data && this.data.escenarios) || [];
  }

  guardar() {
    if (this.form.invalid) {
      Object.keys(this.form.controls).forEach(k => this.form.get(k).markAsTouched());
      return;
    }
    const raw = this.form.value;
    const payload = {
      id: raw.id,
      idescenario: Number(raw.idescenario),
      idareaagente: Number(raw.idareaagente),
      puede_ver_alarmas: raw.puede_ver_alarmas ? 1 : 0,
      puede_gestionar: raw.puede_gestionar ? 1 : 0,
      estado: raw.estado ? 1 : 0
    };
    const endpoint = this.esEdicion ? 'escenarioAreaActualizar' : 'escenarioAreaCrear';
    this.guardando = true;
    this.gateway.get(endpoint, payload).then((res: any) => {
      this.guardando = false;
      if (res && res.response === 1) {
        this.snackbar.open(res.message || 'Guardado', 'Cerrar', { duration: 3000 });
        this.dialogRef.close(true);
      } else {
        this.snackbar.open((res && res.message) || 'Error al guardar', 'Cerrar', { duration: 5000 });
      }
    }).catch(() => {
      this.guardando = false;
      this.snackbar.open('Error al guardar', 'Cerrar', { duration: 5000 });
    });
  }

  cancelar() {
    this.dialogRef.close(false);
  }
}
